/**
 * Plain text for a place that takes HTML - an ECharts tooltip formatter's string, above all.
 *
 * Chart tooltips are built as HTML, and much of what goes into them comes from the database: object
 * names and descriptions (the engineer's own words), version types, vault and location names, and
 * the descriptions the scanner writes into anomaly data (file names among them). Interpolated as
 * they were, any of these holding markup would have run in every viewer's browser (security review,
 * 22 Oct 2026). Every such value goes through this.
 *
 * Not for rich text: an engineer's formatted update is cleaned with sanitizeRichText
 * (lib/sanitize-html.ts) so that its formatting survives. This shows the text exactly as written.
 */
const ENTITIES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }

export function escapeHtml(value: unknown): string {
    return String(value ?? '').replace(/[&<>"']/g, (c) => ENTITIES[c])
}
